initImageZoom({
  moduleSelector: '.detail-module',
  innerSelector: '.detail-module__featured-image__inner',
  duration: '50%',
  triggerHook: 0.2,
});
